import './ModifierPage.less';

export const prefix = 'bm-p-modifier';

export { default } from './ModifierPage';
